export default () => {
  let triggers = document.querySelectorAll("[data-video-modal-target]");
  let currentlyOpenModal = null;
  let lastFocus = null; //the object last focused before the modal opened

  let isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  for (let i = 0; i < triggers.length; i++) {
    triggers[i].addEventListener("click", function (e) {
      e.preventDefault();

      if (isMobile.any()) {
        //on mobile we just open directly in the browser
        let id_to_open = this.getAttribute("data-video-modal-target");
        let target = document.querySelectorAll(
          "[data-video-modal-id='" + id_to_open + "']"
        )[0];
        console.log(target);
        let iframe = target.querySelector("iframe");
        console.log(iframe);
        let src = iframe.getAttribute("src");
        console.log(src);
        window.open(src, "_blank");
      } else {
        lastFocus = document.activeElement;
        let id_to_open = this.getAttribute("data-video-modal-target");
        let target = document.querySelectorAll(
          "[data-video-modal-id='" + id_to_open + "']"
        )[0];
        target.classList.add("open");
        target.ariaToggle("aria-hidden");
        currentlyOpenModal = target;
        currentlyOpenModal.focus();
      }
    });
  }

  let close = document.querySelectorAll(".video_embed_lightbox .close");
  for (let i = 0; i < close.length; i++) {
    close[i].addEventListener("click", function (e) {
      e.preventDefault();
      let id_to_close = this.getAttribute("data-video-modal-close");
      let target = document.querySelectorAll(
        "[data-video-modal-id='" + id_to_close + "']"
      )[0];
      target.classList.remove("open");
      target.ariaToggle("aria-hidden");

      // stop playback if the video is still running
      let iframe = target.querySelector("iframe");
      let src = iframe.getAttribute("src");
      iframe.setAttribute("src", "/stop_playback.html");
      iframe.setAttribute("src", src);

      currentlyOpenModal = null;
      lastFocus.focus();
    });
  }

  document.addEventListener(
    "focus",
    function (e) {
      if (
        currentlyOpenModal != null &&
        !currentlyOpenModal.contains(e.target)
      ) {
        e.stopPropagation();
        let focusPoint = currentlyOpenModal.querySelector("button");
        focusPoint.focus();
      }
    },
    true
  );

  document.onkeydown = function (e) {
    if (e.key === "Escape") {
      //ESC keycode
      if (currentlyOpenModal != null) {
        currentlyOpenModal.classList.remove("open");
        currentlyOpenModal.ariaToggle("aria-hidden");
        currentlyOpenModal = null;
        lastFocus.focus();
      }
    }

    //disable arrow keys to prevent screen readers from wandering out by mistake
    if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
      if (currentlyOpenModal != null) {
        e.preventDefault();
      }
    }
  };
};
